import type { BloomMenuTheme } from '@iheartjane/data-access';
import { FLAGS } from '@iheartjane/feature-flags';
import type { FeatureFlag } from '@iheartjane/feature-flags';
import { PRODUCT_CARD_SIZE_MAP } from '@iheartjane/menu';

export const DEFAULT_PRODUCT_CARD_WIDTH = 240;

export function getThemedProductCardWidth(
  featureFlags: Partial<Record<FeatureFlag, boolean>>,
  theme: BloomMenuTheme
): number {
  const useCustomComponents = featureFlags[FLAGS.c2CustomComponents] ?? false;
  const cardSize = theme?.bloom?.product_cards?.card_size;
  const cardWidth = cardSize ? PRODUCT_CARD_SIZE_MAP[cardSize] : undefined;

  return useCustomComponents && cardWidth
    ? cardWidth
    : DEFAULT_PRODUCT_CARD_WIDTH;
}
